import { AdresseForm } from '@mairistem/adresses';

import type { AdresseType } from '@/types';

interface RegieAdresseListItemFormProps {
  adresse: AdresseType;
  onChange: (e) => void;
}

const RegieAdresseListItemForm = (props: RegieAdresseListItemFormProps) => {
  const { adresse, onChange } = props;

  return (
    <AdresseForm
      adresse={{
        ...adresse,
        type: adresse?.type === 'Hors commune' ? 'Hors Commune' : adresse?.type,
      }}
      onChange={onChange}
      onItemChange={(data) => {
        onChange({ target: { name: 'adresse', value: data?.adresse } });
      }}
    />
  );
};

export default RegieAdresseListItemForm;
